import { Pipe, PipeTransform } from '@angular/core';
import { getNestedObjectValuesByString } from '../helper';
import { DropdownModel } from 'src/app/core/data/model';

type DropDownFilter<T> = T & {hidden?: boolean}

@Pipe({
  standalone: true,
  name: 'dropDownFilter',
})
export class DropDownFilterPipe<T extends DropdownModel> implements PipeTransform {
  constructor() { }

  transform(list: T[], searchText: string, searchKey: string): T[] {
    let filteredList: DropDownFilter<T>[] = [];
    if (!searchText) {
      return list;
    } else {
      for (const item of list) {
        let value;
        value = getNestedObjectValuesByString(item as Object, searchKey);
        value = value ? `${value}` : '';
        if (!value.toLowerCase().includes(searchText.toLowerCase())) {
          filteredList.push({...item, hidden: true, dropDownDisplayName: item['dropDownDisplayName']})
        }else {
          filteredList.push({...item, hidden: false, dropDownDisplayName: item['dropDownDisplayName']})
        }
      }
      return filteredList;
    }
  }
}